import { USER_REQUEST_BY_ID, USER_UPDATE, USER_ADD, USER_SEND_COI_REMINDER } from '@/store/actions/user';
import { AUTH_LOGOUT } from '@/store/actions/auth';
import { mapState, mapGetters } from 'vuex';

import { UserRoles } from '@/lib/userRoles';

import { User } from '@/lib/user.js';

export default {
  name: 'user-editor',
  components: {},
  props: [],
  data () {
    return {
      user: new User,
      roles: [
        { value: UserRoles.office, text: this.$t('message.User.roles.' + UserRoles.office) },
        { value: UserRoles.guidelinesAndPublicationsCouncil, text: this.$t('message.User.roles.' + UserRoles.guidelinesAndPublicationsCouncil) },
        { value: UserRoles.committeeUser, text: this.$t('message.User.roles.' + UserRoles.committeeUser) },
        { value: UserRoles.nationalDelegate, text: this.$t('message.User.roles.' + UserRoles.nationalDelegate) },
        { value: UserRoles.external, text: this.$t('message.User.roles.' + UserRoles.external) },
        { value: UserRoles.internalGroupsOfficer, text: this.$t('message.User.roles.' + UserRoles.internalGroupsOfficer) },
      ],
      showValidateErrors: false,
      changePassword: false
    }
  },
  computed: {
    ...mapState({
      dataLoading: state => state.user.status === 'loading',
    }),
    ...mapGetters([
      'getCurrentPage'
    ]),
  },
  mounted () {
    if (this.$route.params.id != undefined) {
      this.getData();
    } else {
      this.changePassword = true;
    }
  },
  methods: {
    update() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.$swal({
            title: 'Error!',
            text: this.$t("message.fillRequiredFields"),
            type: 'error',
            confirmButtonText: 'OK'
          });
          this.showValidateErrors = true;
        } else {
          this.$store.dispatch(USER_UPDATE, this.user).then((response) => {
            if (this.$store.getters.getUserData.id == response.data.data.id) {
              this.$store.commit('store_user', response);
            }

            this.$swal({
              title: this.$t("message.success"),
              html: this.$t("message.User.successfullyUpdated", {user: response.data.data.name}),
              type: 'success',
              showCancelButton: true,
            });
          }).catch((error) => {
            this.handleUnauth(error.response.status);
            this.handleForbidden(error.response.status);
            this.handleUnprocessable(error.response);
          });
        }
      });
    },

    store() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.$swal({
            title: 'Error!',
            text: this.$t("message.fillRequiredFields"),
            type: 'error',
            confirmButtonText: 'OK'
          });
          this.showValidateErrors = true;
        } else {
          this.$store.dispatch(USER_ADD, this.user).then((response) => {
            if (this.$store.getters.getUserData.id == response.data.data.id) {
              this.$store.commit('store_user', response.data);
            }

            this.user = response.data.data;
            this.changePassword = false;

            this.$swal({
              title: this.$t("message.success"),
              html: this.$t("message.User.successfullyCreated", {user: response.data.data.name}),
              type: 'success',
              showCancelButton: true,
            }).catch((error) => {
              this.handleUnauth(error.response.status);
              this.handleForbidden(error.response.status);
              this.handleUnprocessable(error.response);
            });

            this.$router.push('/users/' + response.data.data.id + '/edit' );
          });
        }
      });
    },

    getData() {
      this.$store.dispatch(USER_REQUEST_BY_ID, this.$route.params.id).then((response) => {
        this.user = response.data.data;
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },
  }
}
